import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { InsurerReportEntryOptionsCellTemplate } from "../customcells/InsurerReportEntryOptionsCellTemplate";

class InsurerReportEntryOptionsCellTypeHandler implements ICellTypeHandler {
  cellType = "insurerreportentryoptions";
  isCustom = true;
  instance = new InsurerReportEntryOptionsCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as any).text;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const [
      ,
      {
        setInsurerReportsStoreValues,
        matchInsurerReportEntry,
        applyInsurerReportEntry,
        getMatchedTargetInfo,
      },
    ] = context["insurerReportsStore"];
    const { t } = context;

    const matched =
      entry.paymentId !== null || entry.paymentPlanEntryId !== null;

    return {
      type: "insurerreportentryoptions",
      rowId: entry[keyColumn],
      matched,
      selected: rowsMetadataMap[entry[keyColumn]]?.selected ?? false,
      highlighted: rowsMetadataMap[entry[keyColumn]]?.highlighted ?? false,
      matchFn: (rowId) => {
        setInsurerReportsStoreValues({
          matchInsurerReportEntryDialog: {
            isOpen: true,
            insurerReportEntryId: rowId,
          },
        });
      },
      unmatchFn: (rowId) => {
        matchInsurerReportEntry(
          {
            insurerReportEntryId: rowId,
            paymentId: null,
            paymentPlanEntryId: null,
          },
          // patch the single entry the endpoint returns; a full reload here
          // would close the open entry lists and drop the report selection
          (updatedEntry) => applyInsurerReportEntry(updatedEntry)
        );
      },
      viewFn: () => {
        getMatchedTargetInfo(
          {
            paymentId: entry.paymentId,
            paymentPlanEntryId: entry.paymentPlanEntryId,
            // needed to scope the payment query to the report's GrECo company
            insurerReportId: entry.insurerReportId,
            t,
          },
          () => {
            setInsurerReportsStoreValues({
              infoInsurerReportEntryDialog: {
                isOpen: true,
                insurerReportEntryId: entry[keyColumn],
              },
            });
          }
        );
      },
      t,
    };
  };
}

export default InsurerReportEntryOptionsCellTypeHandler;
